import {
    type CreateNewsResponseType,
    type CreateNewsRequestType
} from "./type";
import {
    request
} from "../request";

const CreateNews = async (params: CreateNewsRequestType): Promise<CreateNewsResponseType> => {
    return await request<CreateNewsResponseType>("/news/createNews", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default CreateNews;
